export function AutoUnsubPortal() {
    // tslint:disable-next-line:only-arrow-functions
    return function (constructor) {
        const original = constructor.prototype.ngOnDestroy;
        constructor.prototype.ngOnDestroy = function () {
            // tslint:disable-next-line:forin
            for (const prop in this) {
                const property = this[prop];
                if (property !== undefined && property !== null && prop === "_destroy$") {
                    try {
                        property.next();
                        property.complete();
                        property.unsubscribe();
                    }
                    catch (Exception) {
                        // ignore, this should not break afla
                    }
                }
                else if (property !== undefined && property !== null && property.hasOwnProperty("_finalizers") && property["_finalizers"] !== null && property["_finalizers"].length > 0) {
                    try {
                        property.unsubscribe();
                    }
                    catch (e) {
                        // ignore the erorr, if the function does not have unsubscribe it should not cause the viewer to show an error
                    }
                }
            }
            original?.apply(this);
        };
    };
}
